<template>
  <div class="dsf-question-item">
    <div class="dsf-exam-title">
      <div class="exam-title">
        <div>{{ itemsType ? `（${examIndex}）` : examIndex + `.&nbsp;` }}</div>
        <el-popover
          ref="popover"
          placement="right"
          trigger="hover"
          width="200"
          :disabled="!titleImg"
          :popper-options="{ boundariesElement: 'viewport', removeOnDestroy: true }"
        >
          <el-image :src="dsf.url.getWebPath(titleImg)">
            <div slot="error" class="image-slot">
              <i class="iconfont icon-tupianjiazaishibai err-img"></i>
            </div>
          </el-image>
        </el-popover>
        <div
          v-if="subjects.items.value !== 'input'"
          v-html="subjects.name"
          @click="showImage"
          class="title-name"
          v-popover:popover
          @mouseover="showPopver"
        ></div>
      </div>
      <div class="icon-button" v-if="!readOnly || type == 'practice'">
        <i
          v-if="showConsult"
          :class="['tools iconfont icon-icon_ct', showStatus ? 'active' : '']"
          title="查阅"
          @click="handlerEvent('consult', subjects)"
        >
        </i>
        <i
          v-if="!hideMark"
          :class="['tools iconfont icon-biaoji', subjects.marked ? 'active' : '']"
          title="标记"
          @click="handlerEvent('mark', subjects)"
        ></i>

        <el-popover
          :ref="`popover-${subjects.examQuestionsId}`"
          class="error-pop"
          :append-to-body="false"
          @after-leave="closeHander"
          popper-class="correct-review"
          placement="left-end"
          width="300"
          trigger="click"
        >
          <dsf-view-part v-if="correctReview" :independent="true" :is-open-dialog="true" :path="correctReviewUrl" :show-model="'full'" />
          <i slot="reference" class="tools iconfont icon-icon_ct" title="纠错" @click="handlerEvent('error', subjects)"></i>
        </el-popover>
        <i
          v-if="(type == 'practice' || exam.showHint) && subjects.hint"
          class="tools iconfont icon-icon_tips1"
          @click="handlerEvent('tips', subjects)"
          title="提示"
        ></i>
      </div>
    </div>
    <component
      :is="componentIs[subjects.items.value]"
      :previewStatus="previewStatus"
      :readOnly="readOnly"
      :subjects="subjects"
      :items-type="itemsType"
      @show-image="showImage"
    ></component>
    <div class="exam-answer-analysis" v-if="subjects.showStatus || showStatus">
      <div>
        <template v-if="subjects.items.value != 'subjective'">
          <span class="answer"> 标准答案 </span>
          <span class="value">{{ subjects.answerValue }}</span>
        </template>
        <span v-if="type !== 'practice'" class="res-score">
          {{ showScore ? `本题得分：${subjects.resScore !== null ? subjects.resScore : ""}` : "" }}
        </span>
      </div>
      <div class="analysis" v-html="'试题解析：' + (subjects.parse === null ? '' : subjects.parse)" @click="showImage"></div>
    </div>
  </div>
</template>
<script>
import { DsfExamFill, DsfExamTrueFalse, DsfExamRadioBox, DsfExamCheckBox, DsfExamSubjective } from "../components/index";
export default dsf.component({
  name: "DsfExamItem",
  ctrlCaption: "考试项",
  inject: ["exam"],
  components: {
    DsfExamFill,
    DsfExamTrueFalse,
    DsfExamRadioBox,
    DsfExamCheckBox,
    DsfExamSubjective,
  },
  props: {
    type: {
      // exam practice
      type: String,
      default: "exam",
    },
    readOnly: {
      type: Boolean,
      default: true,
    },
    showConsult: {
      type: Boolean,
      default: false,
    },
    hideMark: {
      type: Boolean,
      default: false,
    },
    previewStatus: {
      type: Boolean,
      default: false,
    },
    subjects: {
      type: Object,
      default() {
        return {};
      },
    },
    examIndex: {
      type: [Number, String],
      default: 1,
    },
    itemsType: {
      type: String,
      default: "",
    },
    showScore: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      componentIs: {
        radio: DsfExamRadioBox.name,
        checkbox: DsfExamCheckBox.name,
        judge: DsfExamTrueFalse.name,
        input: DsfExamFill.name,
        subjective: DsfExamSubjective.name,
      },
      srcList: "",
      showStatus: false,
      titleImg: false,
      correctReview: false,
      correctReviewUrl: null,
    };
  },
  created() {
    this.showStatus = this.previewStatus;
    // this.previewStatus =
    //   this.$route?.query?.type != "preview" &&
    //   this.$route?.query?.type != "manage"
    //     ? true
    //     : false;
  },
  methods: {
    // 监听弹框显示时的方法
    showPopver(e) {
      this.$nextTick(() => {
        if (e.target.nodeName.toLowerCase() === "img") {
          this.$refs.popover.updatePopper(); // 用来重新计算位置
          this.titleImg = e.target.src;
          this.$refs.popover.doShow();
        } else {
          this.titleImg = false;
          // this.$refs.popover.doClose();
        }
      });
    },
    showImage(e) {
      let imgs = [];
      // 列表点击是数据  标签内点击是标签
      if (_.isArray(e)) {
        _.forEach(e, (v) => {
          imgs.push(dsf.url.getWebPath(v.relativePath));
        });
      } else if (e.target.nodeName.toLowerCase() === "img") {
        imgs = [e.target.src];
      }
      if (imgs === "[]" || _.isEqual(imgs, [])) {
        return;
      }
      this.$emit("add-show-image", imgs);
    },
    // icon操作
    handlerEvent(type, subjects) {
      const handler = {
        error: () => {
          let showViewId = subjects.examQuestionsId;
          this.correctReview = true;
          this.correctReviewUrl = "/pc/exam/questions/correct/edit?questionId=" + showViewId;
        },
        mark: () => {
          this.$set(subjects, "marked", !subjects.marked);
        },
        tips: () => {
          dsf.layer.alert(`<pre class="exam-hint-tips"> ${subjects.hint} </pre>`);
        },
        consult: () => {
          this.showStatus = !this.showStatus;
        },
      };
      handler[type] && handler[type]();
    },
    closeHander() {
      this.correctReview = false;
    },
  },
});
</script>
